/***
*
*   LOADER
*   Infinite spinning animation for loading states.
*
*   DOCS
*   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/loader
*
*   PROPS
*   className: custom styling (SCSS or tailwind style, optional)
* 
**********/

import { cn, Icon } from 'components/lib';

export function Loader({ className }){

  return <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 inline-block'><Icon name='loader-circle' className={ cn(' mt-[-11px] ml-[-11px] w-[22px] h-[22px] animate-spin', className) }/></div>

}